import { forwardRef } from 'react';
import { type ColorlessIconProps, SVGContainer } from '@direct-frontend/components';

const IconSelectCircle24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectCircle24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <circle cx="12" cy="12" r="10" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconSelectCircle = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectCircle(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    return <IconSelectCircle24 {...iconProps} />;
});
